import { useState, useEffect } from 'react';

const DEFAULT_OPTIONS = {
  config: { attributes: true, childList: true, subtree: true },
};

export default function useMutationObserver(targetEl, callback, options = DEFAULT_OPTIONS) {
	const [observer, setObserver] = useState(null);
	
	useEffect(() => {
    	const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    	const obs = new MutationObserver(callback);
    	setObserver(obs);
  	}, [callback, options, setObserver]);

  	useEffect(() => {
 		if (!observer) return;
    	const { config } = options;
    	observer.observe(targetEl, config);
    	return () => {
      		if (observer) {
        		observer.disconnect();
      		}
    	};
  	}, [observer, targetEl, options]);
}